import { render, staticRenderFns } from "./createModel.vue?vue&type=template&id=9f89dfb6&scoped=true"
import script from "./createModel.vue?vue&type=script&lang=js"
export * from "./createModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f89dfb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f89dfb6')) {
      api.createRecord('9f89dfb6', component.options)
    } else {
      api.reload('9f89dfb6', component.options)
    }
    module.hot.accept("./createModel.vue?vue&type=template&id=9f89dfb6&scoped=true", function () {
      api.rerender('9f89dfb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/appVersion/components/createModel.vue"
export default component.exports